import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  AppBar,
  Toolbar,
  Drawer,
  IconButton,
  Hidden,
  Container,
  Grid,
} from "@material-ui/core";
import { Link } from "react-router-dom";
import {
  sectionLinks,
  sectionLinks2,
  footerLinks,
  mobfooterLinks,
  mobilesectionLinks2,
} from "./utils";
import { useSelector, useDispatch } from "react-redux";
import { AutoSuggestField } from "../../components";
import Group from "../../assets/images/Group.svg";
import Doctall from "../../assets/images/doctall.svg";
import Logo from "../../assets/images/logo.svg";
import AppStore from "../../assets/images/AppStore.svg";
import GooglePlay from "../../assets/images/GooglePlay.svg";
import Icon from "../../assets/images/Icon.svg";
import Icon2 from "../../assets/images/Icon2.svg";
import Icon4 from "../../assets/images/Icon4.svg";
import Icon5 from "../../assets/images/linkedIN.svg";
import Close from "../../assets/images/close.svg";
import DownArrow from "../../assets/images/sectionarrow.svg";
import MenuIcon from "../../assets/images/MobMenu.png";
import SearchIcon from "../../assets/images/MobSearch.png";
import FooterIcon from "../../assets/images/MobFooterDrop.png";
import SearchBack from "../../assets/images/searchBack.svg";
import SearchClose from "../../assets/images/searchClose.svg";
import DropItem from "../../assets/images/dropSys.svg";
import RadioDrop from "../../assets/images/radiodrop.svg";
import { useHistory } from "react-router-dom";
import useOnClickOutside from "../../hooks/useOutsideClickhandler";
import { logout, SearchVal } from "../../redux/auth/actions";
import useWindowSize from "../../hooks/useWindowSize";
import axios from "axios";
import { useCookies } from "react-cookie";
import styles from "./styles";
import "./HeaderFooterStyles.scss";
import { passcodeKey, tokenKey, usernameKey } from "../../utils/constants";

const useStyles = makeStyles((theme) => styles(theme));

/**
 *
 * @param {object} props
 * @returns
 */
export default function HeaderAndFooter(props) {
  const history = useHistory();
  const dispatch = useDispatch();
  const user = useSelector((state) => state.auth);
  const [auth, setAuth] = useState(false);
  const [searchValue, setSearchValue] = useState();
  const { children, searching } = props;
  const [drawerOpen, setDrawer] = React.useState(false);
  const [submenu, setMenu] = React.useState("Dianostic");
  const [authMenu, setAuthMenu] = useState(false);
  const classes = useStyles();
  const [width, height] = useWindowSize();
  const [mobileview, setMobileView] = useState(false);
  const [sideoption, setsideoption] = useState("");
  const [searchselection, setSearchselection] = useState(false);
  const [searchtxt, setsearchtxt] = useState("");
  const [fetchData, setFetchData] = useState([]);
  const [cookies, setCookie] = useCookies([usernameKey, passcodeKey, tokenKey]);
  const [footer, setfooterselection] = useState([]);
  const [update, setupdate] = useState(false);
  useEffect(() => {
    if (width && width < 960) {
      setMobileView(true);
    } else {
      setMobileView(false);
    }
  }, [width]);
  const handleDrawerToggle = () => {
    setDrawer(!drawerOpen);
  };
  useEffect(() => {
    if (user.isAuthenticated === true && user.verified === true) {
      setAuth(true);
    } else {
      setAuth(false);
    }
  }, [user.isAuthenticated]);
  const setfooter = (type) => {
    let arr = footer;
    if (footer.indexOf(type) > -1) {
      arr = footer.filter((e) => e != type);
    } else {
      arr.push(type);
    }
    setfooterselection(arr);
    setupdate(!update);
  };
  const apiFetch = async (val) => {
    await axios
      .get(
        `${process.env.REACT_APP_API_URL}/labtest/diagnostic/searchLists?value=${val}`
      )
      .then((res) => {
        if (res.statusText === "OK" || res.status === 200) {
          let brdata = [];
          res.data.data.map((i) => {
            brdata.push({ name: i.standardisedtestname, uuid: i.uuid });
          });
          setFetchData(brdata);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  function escapeRegexCharacters(str) {
    return str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  }
  function getSuggestions(value) {
    const escapedValue = escapeRegexCharacters(value.trim());

    if (escapedValue === "") {
      return [];
    }

    const regex = new RegExp("^" + escapedValue, "i");

    return fetchData.filter((i) => regex.test(i.name));
  }
  const onChange = (event) => {
    setsearchtxt(event.target.value);
    apiFetch(event.target.value);
    if (event.target.value.length === 0) {
      dispatch(SearchVal(...getSuggestions(event.target.value)));
    }
  };
  const onClear = () => {
    setsearchtxt("");
    setSearchselection(false);
    setFetchData([]);
    dispatch(SearchVal(...getSuggestions("")));
  };
  return (
    <div>
      <AppBar className={classes.appBar}>
        <Toolbar className={classes.container}>
          <Hidden smDown>
            <Grid
              container
              alignItems="center"
              justify="center"
              className={classes.sectionLinks}
            >
              {(sectionLinks || []).map((s) => (
                <Grid key={s.id} item>
                  <a
                    target="_blank"
                    style={{ fontFamily: "visuelt-regular", fontSize: 14 }}
                    href={s.path}
                  >
                    {s.label}
                  </a>
                </Grid>
              ))}
            </Grid>
            <Grid
              container
              justify="space-between"
              alignItems="center"
              className={classes.middleSection}
            >
              <Grid item>
                <img
                  src={Doctall}
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    history.push("/");
                  }}
                  alt="doctall logo"
                />
              </Grid>
              <Grid item>
                <AutoSuggestField />
              </Grid>
              <div className="menulistresponive">
                <Grid
                  container
                  justify="space-between"
                  alignItems="center"
                  style={{ minWidth: "240px" }}
                >
                  <Grid item>
                    <a
                      style={{ fontFamily: "visuelt-regular", fontSize: 16 }}
                      // href="https://more.doctall.com/faq/"
                      href="/faq"
                      // target="_blank"
                      rel="noreferrer"
                    >
                      FAQs
                    </a>
                  </Grid>
                  {auth ? (
                    <>
                      <Grid item>
                        <Link
                          onClick={() => {
                            history.push("/shoppingCart");
                          }}
                          className={classes.group}
                        >
                          <img
                            src={
                              require("../../assets/images/cart.svg").default
                            }
                            alt=""
                          />
                          Cart
                        </Link>
                      </Grid>
                      <Grid item>
                        <Link
                          className={classes.group}
                          style={{ position: "relative" ,width:"20%"}}
                          onClick={() => {
                            authMenu === false
                              ? setAuthMenu(true)
                              : setAuthMenu(false);
                          }}
                        >
                          {user && user.profile && user.profile.profile_pic ? (
                            <img 
                              src={user.profile.profile_pic}
                              alt="group"
                              className="mob-profile"
                            />
                          ) : (
                            <img
                              src={Group}
                              alt="group"
                              className="mob-profile"
                            />
                          )}
                          {authMenu ? (
                            <div className={classes.hideDiv}>
                              <p
                                className={classes.hideDivElements}
                                onClick={() => {
                                  setCookie(usernameKey, null);
                                  setCookie(passcodeKey, null);
                                  setCookie(tokenKey, null);
                                  dispatch(logout());
                                  history.push("/");
                                }}
                              >
                                logout
                              </p>
                              <p
                                className={classes.hideDivElements}
                                onClick={() => {
                                  history.push("/cart-update");
                                }}
                              >
                                addRecipient
                              </p>
                            </div>
                          ) : null}
                        </Link>
                      </Grid>
                    </>
                  ) : (
                    <Grid item>
                      <Link to="/login" className={classes.group}>
                        <img src={Group} alt="group" />
                        Login
                      </Link>
                    </Grid>
                  )}
                </Grid>
              </div>
            </Grid>
            <Grid
              container
              alignItems="center"
              justify="space-between"
              className={classes.sectionLinks2}
            >
              <Grid item md={6}>
                <Grid container alignItems="center">
                  <div
                    style={{
                      display: "flex",
                      paddingLeft: "6%",
                      width: "100%",
                    }}
                  >
                    <div
                      style={{
                        paddingRight: "3%",
                        display: "flex",
                        cursor: "pointer",
                      }}
                    >
                      <span
                        onClick={() => {
                          setMenu("Dianostic");
                        }}
                      >
                        {" "}
                        Diagnostic Tests
                      </span>{" "}
                      <DropClick />
                      {submenu == "Dianostic" && (
                        <div
                          style={{
                            backgroundColor: "#FFAD05",
                            height: 4,
                            width: 125,
                            bottom: 0,
                            position: "absolute",
                          }}
                        />
                      )}
                    </div>
                    <div
                      style={{
                        paddingRight: "2%",
                        display: "flex",
                        cursor: "pointer",
                      }}
                    >
                      <span
                        onClick={() => {
                          setMenu("BioCheck");
                        }}
                      >
                        BioCheck Panels{" "}
                      </span>
                      <DropClick />
                      {submenu == "BioCheck" && (
                        <div
                          style={{
                            backgroundColor: "#FFAD05",
                            height: 4,
                            width: 125,
                            bottom: 0,
                            position: "absolute",
                          }}
                        />
                      )}
                    </div>
                  </div>
                  {(sectionLinks2 || [])
                    .filter((_) => _.view === "md")
                    .map((s) => (
                      <Grid key={s.id} item className={classes.subLinks}>
                        <Link to={s.path}>
                          {s.label}
                          {s.icon ? (
                            <img
                              src={s.icon}
                              className={classes.icon}
                              alt="icon"
                            />
                          ) : null}
                        </Link>
                        {s.childRoutes && s.childRoutes.length > 0 ? (
                          <div className={`dropdownList ${classes.ckbd}`}>
                            {(s.childRoutes || []).map((t) => (
                              <Grid key={t.id} item>
                                <Link to={t.path}>{t.label}</Link>
                              </Grid>
                            ))}
                          </div>
                        ) : null}
                      </Grid>
                    ))}
                </Grid>
              </Grid>
              <Grid item md={6}>
                <Grid container alignItems="center" justify="flex-end">
                  <Grid item className={classes.subLinks}>
                    <Link
                      to={"/"}
                      style={{ fontFamily: "visuelt-regular", fontSize: 16 }}
                    >
                      Find Partner Branch
                    </Link>
                  </Grid>
                  <Grid item className={classes.subLinks}>
                    <a
                      href="https://forms.clickup.com/f/4hnn1-543/J66634MTO2OOU28XUR/"
                      style={{ fontFamily: "visuelt-regular", fontSize: 16 }}
                      target="_blank"
                      rel="noreferrer"
                    >
                      Contact Us
                    </a>{" "}
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Hidden>
          <Hidden mdUp>
            <Grid
              container
              justify="space-between"
              alignItems="center"
              className="mobhead-container"
            >
              {!searchselection ? (
                <>
                  <Grid item>
                    <IconButton
                      aria-label="open drawer"
                      onClick={handleDrawerToggle}
                    >
                      <img src={MenuIcon} alt="menuicon" className="mob-menu" />
                    </IconButton>
                    <img
                      src={Doctall}
                      alt="doctall"
                      className="mob-logo"
                      onClick={() => {
                        history.push("/");
                      }}
                    />
                  </Grid>
                  <Grid item style={{ display: "flex" }}>
                    <IconButton
                      aria-label="open drawer"
                      onClick={() => {
                        setSearchselection(true);
                      }}
                    >
                      <img
                        src={SearchIcon}
                        alt="search-menu"
                        className="mob-search"
                      />
                    </IconButton>
                    {auth ? (
                      <Link
                        className={classes.group}
                        style={{ position: "relative" }}
                        onClick={() => {
                          authMenu === false
                            ? setAuthMenu(true)
                            : setAuthMenu(false);
                        }}
                      >
                        <div>
                          {user && user.profile && user.profile.profile_pic ? (
                            <img
                              src={user.profile.profile_pic}
                              alt="group"
                              className="mob-profile"
                            />
                          ) : (
                            <img
                              src={Group}
                              alt="group"
                              className="mob-profile"
                            />
                          )}
                        </div>
                        {authMenu ? (
                          <div className={classes.hideDiv}>
                            <p
                              className={classes.hideDivElements}
                              onClick={() => {
                                dispatch(logout());
                                history.push("/");
                              }}
                            >
                              logout
                            </p>
                            <p
                              className={classes.hideDivElements}
                              onClick={() => {
                                history.push("/cart-update");
                              }}
                            >
                              addRecipient
                            </p>
                          </div>
                        ) : null}
                      </Link>
                    ) : (
                      <Link to="/login" className={classes.group}>
                        <img src={Group} alt="group" className="mob-profile" />
                      </Link>
                    )}
                    {/* <Link to="/login"><IconButton
                       aria-label="open drawer"
                       onClick={() => { }}
 
                     >
                      <img src={Group} alt="profile-menu" className="mob-profile" />
                     </IconButton></Link> */}
                  </Grid>
                </>
              ) : (
                <>
                  <div className="searchContainer">
                    <div
                      className="navBack"
                      onClick={() => {
                        setSearchselection(false);
                      }}
                    >
                      <img src={SearchBack} alt="search-menu" />
                    </div>
                    <div className="mob-search-container">
                      <img
                        src={SearchIcon}
                        alt="search-icon"
                        className="search2Icon"
                      />
                      <input
                        placeholder="Search tests"
                        type="text"
                        value={searchtxt}
                        onChange={onChange}
                      />
                      <img
                        src={SearchClose}
                        onClick={() => {
                          onClear();
                        }}
                        alt="search-menu"
                        className="search2Close"
                      />
                    </div>
                  </div>
                  <div className="searchoverlay">
                    {(fetchData.length > 0 && (
                      <div className="valHolder">
                        <div className="titlesearch">{`Suggestions (${fetchData.length} Matches)`}</div>
                        {fetchData.map((e, i) => {
                          return (
                            <div
                              key={`searchval-${i}`}
                              onClick={() => {
                                dispatch(SearchVal(...getSuggestions(e.name)));
                                history.push("/populartest");
                                setSearchselection(false);
                              }}
                              className="searchlistval"
                            >
                              {e.name}
                            </div>
                          );
                        })}
                      </div>
                    )) ||
                      ""}
                  </div>
                </>
              )}
            </Grid>
          </Hidden>
        </Toolbar>
        <Hidden mdUp implementation="js">
          <Drawer
            variant="temporary"
            anchor={"left"}
            open={drawerOpen}
            classes={{
              paper: classes.drawerPaper,
            }}
            onClose={handleDrawerToggle}
          >
            <Grid container direction="column">
              <Grid item xs={12} style={{ textAlign: "start" }}>
                <IconButton
                  aria-label="open drawer"
                  onClick={handleDrawerToggle}
                  style={{ padding: 15, margin: "0.5em" }}
                >
                  <img src={Close} alt="Close" />
                </IconButton>
              </Grid>
              <Grid
                item
                xs={12}
                style={{ backgroundColor: "#F7F8FB", padding: "15px" }}
              >
                <Grid container direction="column">
                  <div className="mob-category">CATEGORIES</div>
                  {(mobilesectionLinks2 || []).map((s) => (
                    <Grid
                      key={s.id}
                      item
                      xs={12}
                      className={classes.drawerLinks}
                    >
                      <Link
                        onClick={() => {
                          setsideoption(s.label);
                        }}
                        style={{
                          color: "#0c44ac",
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        {s.label}
                        {s.icon ? (
                          <img
                            src={s.icon}
                            className={classes.icon}
                            alt="icon"
                          />
                        ) : null}
                      </Link>
                      {(sideoption == s.label && (
                        <Grid container>
                          {(s.childRoutes || []).map((c) => (
                            <Grid
                              key={s.id}
                              item
                              xs={12}
                              className={classes.drawerLinks}
                            >
                              <Link to={c.path} style={{ color: "#0c44ac" }}>
                                {c.icon ? (
                                  <img
                                    src={c.icon}
                                    style={{ paddingRight: 8, width: 18 }}
                                    alt="icon"
                                  />
                                ) : null}
                                {c.label}
                              </Link>
                            </Grid>
                          ))}
                        </Grid>
                      )) ||
                        ""}
                    </Grid>
                  ))}
                </Grid>
              </Grid>
              <Grid item xs={12} style={{ marginTop: 24, padding: "15px" }}>
                <Grid container direction="column">
                  {(sectionLinks || []).map((s) => (
                    <Grid
                      key={s.id}
                      item
                      xs={12}
                      className={classes.drawerLinks}
                    >
                      <Link style={{ color: "#0c44ac" }} to={s.path}>
                        {s.label}
                      </Link>
                    </Grid>
                  ))}
                </Grid>
              </Grid>

              <Grid item xs={12} style={{ marginTop: 40, padding: "15px" }}>
                <Grid container direction="column">
                  <Grid item xs={12} className={classes.drawerLinks}>
                    <Link to={"/"} style={{ color: "#0c44ac" }}>
                      Find Partner Branch11
                    </Link>
                  </Grid>
                  <Grid item xs={12} className={classes.drawerLinks}>
                    <Link
                      to={
                        "https://forms.clickup.com/f/4hnn1-543/J66634MTO2OOU28XUR/"
                      }
                      style={{ color: "#0c44ac" }}
                    >
                      Contact Us
                    </Link>
                  </Grid>
                  <Grid item xs={12} className={classes.drawerLinks}>
                    <Link to={"/faq"} style={{ color: "#0c44ac" }}>
                      FAQs
                    </Link>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Drawer>
        </Hidden>
      </AppBar>
      <Grid container>{children}</Grid>
    </div>
  );
}
const DropClick = (props) => {
  const ref = React.useRef();
  const [drop, setDrop] = React.useState(false);
  const [selection, setSelection] = React.useState("Pathology");
  useOnClickOutside(ref, () => {
    setDrop(false);
  });
  return (
    <div
      style={{ position: "relative", paddingLeft: 10 }}
      ref={ref}
      onClick={() => {
        setDrop(!drop);
      }}
    >
      <img style={{ cursor: "pointer" }} src={DownArrow} />
      {drop && (
        <div
          style={{
            position: "absolute",
            top: 37,
            right: -35,
            backgroundColor: "#ffffff",
            maxWidth: 235,
            minWidth: 200,
            boxShadow: "0px 4px 6px 2px #F5F9FF",
            border: "1px solid #E3EAF6",
            zIndex: 99,
          }}
        >
          <div
            onClick={() => {
              setSelection("Pathology");
            }}
            style={
              selection == "Pathology"
                ? {
                    color: "#163E8C",
                    fontSize: 16,
                    fontFamily: "visuelt-regular",
                    fontWeight: "500",
                    padding: "10px 20px",
                    display: "flex",
                    alignItems: "center",
                    backgroundColor: "#F2F5FE",
                    borderRightColor: "#FFAD05",
                    borderRightWidth: 2,
                    borderRightStyle: "solid",
                  }
                : {
                    color: "#163E8C",
                    fontSize: 16,
                    fontFamily: "visuelt-regular",
                    fontWeight: "500",
                    padding: "10px 20px",
                    display: "flex",
                    alignItems: "center",
                  }
            }
          >
            <img style={{ paddingRight: 8, width: 18 }} src={DropItem} />
            Pathology
          </div>
          <div
            onClick={() => {
              setSelection("Radiology");
            }}
            style={
              selection == "Radiology"
                ? {
                    color: "#163E8C",
                    fontSize: 16,
                    fontFamily: "visuelt-regular",
                    fontWeight: "500",
                    padding: "10px 20px",
                    display: "flex",
                    alignItems: "center",
                    backgroundColor: "#F2F5FE",
                    borderRightColor: "#FFAD05",
                    borderRightWidth: 2,
                    borderRightStyle: "solid",
                  }
                : {
                    color: "#163E8C",
                    fontSize: 16,
                    fontFamily: "visuelt-regular",
                    fontWeight: "500",
                    padding: "10px 20px",
                    display: "flex",
                    alignItems: "center",
                  }
            }
          >
            <img style={{ paddingRight: 8, width: 18 }} src={RadioDrop} />
            Radiology
          </div>
        </div>
      )}
    </div>
  );
};
